import { proxy } from 'valtio';

import type { Compliance, ComponentType } from 'models';

export type WorkspaceNavItem = {
    title: string;
    href: string;
    highlightPrefixes?: string[];
    items?: { title: string; href: string; description?: string; external?: boolean }[];
};

export type WorkspaceComponentTypeSuggestion = {
    componentType: ComponentType;
    // Manufacturer ids.
    companies: string[];
};

// The public shape of a `workspaces` document, as served by `/api/workspaces/public/:key`.
export type WorkspaceConfigState = {
    // True on a partner workspace host. The main site loads the Direct Energy Partners document for
    // its branding and flags but is not a workspace.
    workspace?: boolean;
    key?: string;
    indexable?: boolean;
    name?: string;
    websiteUrl?: string;
    logoUrl?: string;
    logoWhiteUrl?: string;
    brandColor?: string;
    primaryButtonColor?: string;
    gradientFrom?: string;
    gradientTo?: string;
    footerColor?: string;
    heroImageUrl?: string;
    shareImageUrl?: string;
    faviconUrl?: string;
    homepagePath?: string;
    navLinks?: WorkspaceNavItem[];
    simplifySignup?: boolean;
    hideCredits?: boolean;
    hideSuggestions?: boolean;
    disableDiagramAI?: boolean;
    showReplusLogo?: boolean;
    showContactLink?: boolean;
    showFeedbackLink?: boolean;
    showAnalytics?: boolean;
    memberOrganizations?: Compliance[];
    componentTypeSuggestions?: WorkspaceComponentTypeSuggestion[];
};

export const workspaceConfigState = proxy<{ config: WorkspaceConfigState }>({
    config: {},
});
